import React, { Suspense, lazy, useEffect, useState } from 'react'
import Components from './Components/Components'
import './App.css'
import './design.css'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { isLoggedIn, isAdmin, getRole, setRole, api, trackVisit, trackEvent } from './api'
import { useRouteSeo } from './seo'
import { loginUrl } from './authNext'

// Profil sahifalari login talab qiladi; qaytish manzili saqlanadi (masalan, ijaraga taklif havolasi ?taklif=KOD yo'qolmasin)
function LoginFirst() {
  const { pathname, search } = useLocation();
  return <Navigate to={loginUrl(pathname + search)} replace />;
}
// Bosh sahifadan boshqa sahifalar alohida bo'laklarda — birinchi ochilishda faqat kerakli kod yuklanadi (tezlik / Core Web Vitals)
const Register = lazy(() => import('./Components/Auth/Register'))
const Login = lazy(() => import('./Components/Auth/Login'))
const ForgotPassword = lazy(() => import('./Components/Auth/ForgotPassword'))
const UserAccount = lazy(() => import('./Components/Account/UserAccount'))
const Allpatners = lazy(() => import('./Components/Alladvertising/Allpatners'))
const Allrents = lazy(() => import('./Components/Alladvertising/Allrents'))
const Adinner = lazy(() => import('./Components/Alladvertising/Adinner'))
const PatnerAdinner = lazy(() => import('./Components/Alladvertising/PatnerAdinner'))
const AboutUs = lazy(() => import('./Components/About/AboutUs'))
const WantedList = lazy(() => import('./Components/Wanted/WantedList'))
const AdminReports = lazy(() => import('./Components/Admin/AdminReports'))
const Contract = lazy(() => import('./Components/Contract'))
const AdminPanel = lazy(() => import('./Components/Admin/AdminPanel'))
const NotFound = lazy(() => import('./Components/NotFound'))
const PostAdPage = lazy(() => import('./Components/Profile/PostAdPage'))
const Landing = lazy(() => import('./Components/Alladvertising/Landing'))
const BlogList = lazy(() => import('./Components/Blog/Blog'))
const BlogPost = lazy(() => import('./Components/Blog/Blog').then(m => ({ default: m.BlogPost })))

// Admin uchun faqat admin sahifalari (va moderatsiya uchun e'lon sahifalari) ochiq
const ADMIN_ALLOWED = [/^\/admin(\/|$)/, /^\/addinner\//, /^\/patneraddinner\//];

export default function App() {
  const { pathname } = useLocation();
  useRouteSeo(pathname);
  const [, setRoleLoaded] = useState(0);
  // Har sahifa ochilishi — tashrif; ochiq turgan tab uchun 2 daqiqada bir "ping" (hozir saytdagilar soni uchun)
  useEffect(() => { if (!isAdmin()) trackVisit(pathname); }, [pathname]);
  // Bot xabari (?src=tg) va kanal posti (?src=tg_kanal) havolalari — Telegram orqali qaytganlar alohida hisoblanadi
  useEffect(() => {
    const src = new URLSearchParams(window.location.search).get('src');
    if (isAdmin() || (src !== 'tg' && src !== 'tg_kanal')) return;
    const kind = /^\/(xonadosh|patneraddinner)\//.test(window.location.pathname) ? 'PARTNER' : 'RENT';
    trackEvent('tg_return', src === 'tg_kanal' ? `kanal:${kind}` : kind);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const t = setInterval(() => { if (document.visibilityState === 'visible' && !isAdmin()) trackVisit('__ping'); }, 120000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    // Oldin kirgan foydalanuvchilarda rol saqlanmagan bo'lishi mumkin
    if (isLoggedIn() && !getRole()) api.getUser().then(res => { setRole(res?.element?.role || 'USER'); setRoleLoaded(x => x + 1); });
  }, [pathname]);
  if (isAdmin() && !ADMIN_ALLOWED.some(r => r.test(pathname))) return <Navigate to="/admin" replace />;

  return (
    <div>
      <Suspense fallback={<div className='page-loading' aria-busy='true' />}>
      <Routes>
        <Route path="/" element={<Components />} />
        <Route path="/registr" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/profile/*" element={isLoggedIn() ? <UserAccount /> : <LoginFirst />} />
        <Route path="/allpatneradvertising" element={<Allpatners />} />
        <Route path="/allrentadvertising" element={<Allrents />} />
        <Route path="/patneraddinner/:id" element={<PatnerAdinner />} />
        <Route path="/addinner/:id" element={<Adinner />} />
        <Route path="/contract/:type/:id" element={isLoggedIn() ? <Contract /> : <Navigate to="/login" replace />} />
        <Route path="/admin" element={isLoggedIn() ? <AdminPanel /> : <Navigate to="/login" replace />} />
        <Route path="/admin/reports" element={isLoggedIn() ? <AdminReports /> : <Navigate to="/login" replace />} />
        <Route path="/wanted" element={<WantedList />} />
        <Route path="/elon-joylash" element={<PostAdPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/maslahatlar" element={<BlogList />} />
        <Route path="/maslahatlar/:slug" element={<BlogPost />} />
        <Route path="/ijara/*" element={<Landing />} />
        <Route path="/xonadosh/*" element={<Landing />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
    </div>
  )
}
